import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { Timeline } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";

const LineStringButton: React.FC<IButtonProps> = ({ icon, title = "Draw a line" }) => {
  const { map, drawControl } = useContext(MapContext);

  const handleOnClick = () => {
    drawControl.current.changeMode("draw_line_string");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "draw_line_string" } as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton title={title} value="draw_line_string" onClick={handleOnClick} data-testid="toolbar-linestring-button">
      {icon || <Timeline />}
    </ToolbarToggleButton>
  );
};

export default LineStringButton;
